import * as React from 'react'

import { useGateway } from './hooks'
import {
  CAlert,
  CButton,
  CCard,
  CCardBody,
  CCardHeader,
  CCol,
  CFormCheck,
  CFormInput,
  CMultiSelect,
  CRow,
} from '@coreui/react-pro'
import {
  $exchangerOptions,
  $withdrawalGroups,
  exchangerDataMounted,
  setGateway,
  setGatewayExchanger,
  submitSaveGateway,
} from './model'
import type { UploadProps } from 'antd'
import {
  AutoComplete,
  Button,
  Divider,
  message,
  Typography,
  Upload,
} from 'antd'
import { UploadOutlined } from '@ant-design/icons'
import { processingProvider } from '../../../libs/processingProvider'
import { useCallback, useState } from 'react'
import { useStore, useUnit } from 'effector-react'
import { debounce } from 'lodash'
import { METHOD_KIND } from 'src/pages/gateway/const'
import { transformCountriesToOptions } from 'src/libs/formatCountries'
import { $countriesList } from 'src/features/dictionaries/model'

export const GatewayCreateDetail = () => {
  const { gateway, loading, error, gatewayExchanger } = useGateway()
  const exchangerOptions = useStore($exchangerOptions)
  const countriesList = useUnit($countriesList)
  const withdrawalGroupsOptions = useStore($withdrawalGroups)

  const [ownerName, setOwnerName] = useState('')

  const debounceLoadData = useCallback(debounce(exchangerDataMounted, 1000), [])

  const handleGetClient = (id: string) => {
    if (id.length >= 1) {
      debounceLoadData({ id })
    }
  }

  const props: UploadProps = {
    name: 'file',
    maxCount: 1,
    beforeUpload: (file) => {
      // @ts-ignore
      setGateway({ ...gateway, file: file })
      return false
    },
    onChange(info) {
      if (info.file.status !== 'uploading') {
        console.log(info.file, info.fileList)
      }
      if (info.file.status === 'done') {
        message
          .success(`${info.file.name} file uploaded successfully`)
          .then((r) => console.log(r))
      } else if (info.file.status === 'error') {
        message
          .error(`${info.file.name} file upload failed.`)
          .then((r) => console.log(r))
      }
    },
  }

  const handleChange = (event: {
    target: { name: any; type: string; checked?: any; value: any }
  }) => {
    const value =
      event.target.type === 'checkbox'
        ? event.target.checked
        : event.target.value
    setGateway({
      ...gateway,
      [event.target.name]: value,
    })
  }

  const handleExchangerChange = (event: {
    target: { name: any; type: string; checked?: any; value: any }
  }) => {
    const value =
      event.target.type === 'checkbox'
        ? event.target.checked
        : event.target.value

    setGatewayExchanger({
      ...gatewayExchanger,
      [event.target.name]: value,
    })
  }
  const handleFileChange = (event: any) => {
    const name = event.currentTarget.name
    const myFile = event.currentTarget.files[0]
    let reader = new FileReader()
    reader.readAsDataURL(myFile)
    reader.onload = (e) => {
      // @ts-ignore
      setGateway({ ...gateway, logo: myFile })
    }
  }

  const handleChangeAutoComplete = (value: string) => {
    setOwnerName(value)
  }

  const handleOnSelect = (value: string) => {
    const ownerId = exchangerOptions.find((item) => item.value === value)?.id
    if (ownerId) {
      setGatewayExchanger({
        ...gatewayExchanger,
        ownerId,
      })
      setGateway({
        ...gateway,
        exchangerId: ownerId,
      })
    }
  }

  return (
    <div>
      {error.message.length > 0 && (
        <CAlert color="danger">Error code: {error.message}</CAlert>
      )}
      <CCard className="mb-4">
        <CCardHeader className="d-sm-flex justify-content-between align-items-center">
          <strong>Create gateway</strong>
        </CCardHeader>
        <CCardBody>
          <CRow className="mb-3 align-items-center">
            <CCol>
              <CMultiSelect
                key="withdrawalGroupId"
                id="withdrawalGroupId"
                label="Withdrawal Group"
                multiple={false}
                options={withdrawalGroupsOptions}
                onChange={(event) => {
                  let select: (string | number)[] = []
                  event.forEach((item) => select.push(item.value))
                  handleChange({
                    target: {
                      value: select.pop(),
                      checked: false,
                      name: 'withdrawalGroupId',
                      type: '',
                    },
                  })
                }}
              ></CMultiSelect>
              <CFormInput
                id="psCode"
                name="psCode"
                value={gateway.psCode}
                label="PS Code"
                onChange={handleChange}
              />
              <Upload {...props}>
                <Button icon={<UploadOutlined />}>Click to Upload</Button>
              </Upload>
              <CFormInput
                id="name"
                name="name"
                value={gateway.name}
                label="name"
                onChange={handleChange}
              />
              <CFormInput
                id="internalName"
                name="internalName"
                value={gateway.internalName}
                label="internalName"
                onChange={handleChange}
              />
              <CMultiSelect
                key="paymentMethodType"
                id="paymentMethodType"
                label="paymentMethodType"
                multiple={false}
                options={[
                  {
                    text: 'credit_card',
                    value: 'credit_card',
                    selected: gateway.paymentMethodType == 'credit_card',
                  },
                  {
                    text: 'online_bank',
                    value: 'online_bank',
                    selected: gateway.paymentMethodType == 'online_bank',
                  },
                  {
                    text: 'e_wallet',
                    value: 'e_wallet',
                    selected: gateway.paymentMethodType == 'e_wallet',
                  },
                  {
                    text: 'crypto',
                    value: 'crypto',
                    selected: gateway.paymentMethodType == 'crypto',
                  },
                  {
                    text: 'exchanger',
                    value: 'exchanger',
                    selected: gateway.paymentMethodType == 'exchanger',
                  },
                ]}
                onChange={(event) => {
                  let select: (string | number)[] = []
                  event.forEach((item) => select.push(item.value))
                  handleChange({
                    target: {
                      value: select.pop(),
                      checked: false,
                      name: 'paymentMethodType',
                      type: '',
                    },
                  })
                }}
              ></CMultiSelect>
              {gateway.paymentMethodType === 'exchanger' && (
                <>
                  <CRow className="mb-3 mt-3">
                    <CCol sm={4} className="d-flex flex-column">
                      <Typography.Text>Exchanger owner</Typography.Text>
                      <AutoComplete
                        onChange={(value, option) =>
                          handleChangeAutoComplete(value)
                        }
                        onSelect={handleOnSelect}
                        value={ownerName}
                        options={exchangerOptions}
                        style={{ width: 300 }}
                        onSearch={(text) => handleGetClient(text)}
                      />
                    </CCol>
                  </CRow>
                </>
              )}
              {gateway.paymentMethodType !== 'exchanger' && (
                <>
                  <CMultiSelect
                    key="processingProvider"
                    id="processingProvider"
                    label="processingProvider"
                    multiple={false}
                    options={processingProvider.map((item) => {
                      if (gateway.processingProvider == item.value) {
                        return { ...item, selected: true }
                      } else {
                        return { ...item, selected: false }
                      }
                    })}
                    onChange={(event) => {
                      let select: (string | number)[] = []
                      event.forEach((item) => select.push(item.value))
                      handleChange({
                        target: {
                          value: select.pop(),
                          checked: false,
                          name: 'processingProvider',
                          type: '',
                        },
                      })
                    }}
                  ></CMultiSelect>
                  <CFormInput
                    id="praxisGatewayHash"
                    name="praxisGatewayHash"
                    value={gateway.praxisGatewayHash}
                    label="praxisGatewayHash"
                    onChange={handleChange}
                  />
                </>
              )}
              <CMultiSelect
                key="technicalMethodKind"
                id="technicalMethodKind"
                label="Technical Payment Method Type"
                multiple={false}
                options={[
                  {
                    text: 'Unknown',
                    value: METHOD_KIND.MK_UNKNOWN,
                    // странное поведение BE - передаем MK_UNKNOWN возвращает null
                    selected:
                      gateway.technicalMethodKind === METHOD_KIND.MK_UNKNOWN ||
                      gateway.technicalMethodKind === null,
                  },
                  {
                    text: 'Mobile Money',
                    value: METHOD_KIND.MK_MOBILE_MONEY,
                    selected:
                      gateway.technicalMethodKind ===
                      METHOD_KIND.MK_MOBILE_MONEY,
                  },
                  {
                    text: 'Bank Transfer',
                    value: METHOD_KIND.MK_BANK_TRANSFER,
                    selected:
                      gateway.technicalMethodKind ===
                      METHOD_KIND.MK_BANK_TRANSFER,
                  },
                  {
                    text: 'Local method',
                    value: METHOD_KIND.MK_LOCAL_METHOD,
                    selected:
                      gateway.technicalMethodKind ===
                      METHOD_KIND.MK_LOCAL_METHOD,
                  },
                  {
                    text: 'Crypto',
                    value: METHOD_KIND.MK_CRYPTO,
                    selected:
                      gateway.technicalMethodKind === METHOD_KIND.MK_CRYPTO,
                  },
                ]}
                onChange={(event) => {
                  handleChange({
                    target: {
                      value: event[0]?.value ?? null,
                      name: 'technicalMethodKind',
                      type: '',
                    },
                  })
                }}
              />
              <CMultiSelect
                key="technicalCountryCodeA3"
                id="technicalCountryCodeA3"
                label="Technical country"
                className="mb-3"
                multiple={false}
                virtualScroller
                options={[
                  ...transformCountriesToOptions(countriesList).map(
                    (country) => {
                      if (gateway.technicalCountryCodeA3 == country.value) {
                        return { ...country, selected: true }
                      } else {
                        return { ...country, selected: false }
                      }
                    },
                  ),
                ]}
                onChange={(event) => {
                  handleChange({
                    target: {
                      value: event[0]?.value ?? null,
                      name: 'technicalCountryCodeA3',
                      type: '',
                    },
                  })
                }}
              />
              <CFormCheck
                label="depositVerificationRequired"
                name="depositVerificationRequired"
                id="depositVerificationRequired"
                checked={gateway.depositVerificationRequired}
                onChange={handleChange}
                className="mb-3"
              />
              <CButton
                color="success"
                className="ms-2"
                onClick={() => {
                  submitSaveGateway({ ...gateway })
                }}
              >
                Save gateway
              </CButton>
              <Divider />
            </CCol>
          </CRow>
        </CCardBody>
      </CCard>
    </div>
  )
}
